import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { makeRequest } from "../../utils/axios.js"; 
import '../resetPassword/resetPassword.scss';
import NetworkingVideo from '../../assets/Networking.mp4';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null); 
  const [isLoading, setIsLoading] = useState(false);
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); 
  const token = searchParams.get("token");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
        return setErr("Passwords do not match!");
    }

    setIsLoading(true);
    setErr(null);
    setMsg(null); 

    try {
      const res = await makeRequest.post("/auth/reset-password", { 
          token, 
          newPassword 
      });
      
      setMsg(res.data || "Password has been reset successfully!");
      
      setTimeout(() => {
          navigate("/login");
      }, 2500);

    } catch (error) {
      const errorMessage = error.response?.data?.error 
                         || error.response?.data?.message 
                         || (typeof error.response?.data === 'string' ? error.response?.data : "Invalid or expired token!");
      setErr(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) {
    return (
      <div className='resetPassword'>
        <video autoPlay loop muted playsInline className="video-background">
          <source src={NetworkingVideo} type="video/mp4" />
        </video>

        <div className="video-overlay"></div>
          <div className="card invalid-card">
            <div className="right invalid-request">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="60" height="60" fill="#d32f2f">
                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"></path>
              </svg>

              <h2>
                Invalid Request
              </h2>

              <p>
                Reset token is missing or invalid. Please check your email link again.
              </p>

              <Link to="/login">
                <button type="button">
                  Back to Login
                </button>
              </Link>
            </div>
          </div>
      </div>
    )
  }

  return (
    <div className='resetPassword'>
      <video autoPlay loop muted playsInline className="video-background">
        <source src={NetworkingVideo} type="video/mp4" />
      </video>
      
      <div className="video-overlay"></div>

      <div className="card">
        <div className="left">
          <h1>
            New Password.
          </h1>

          <p>
            Please create a new strong password that you don't use on other websites.
          </p>
        </div>

        <div className="right">
          <h1>
            Reset Password
          </h1>
          
          {msg ? (
             <div className="success-message">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                  <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.76 11.7574L11.0026 16Z"></path>
                </svg>

                <div className="msg-content">
                  <span>
                    {msg}
                  </span>

                  <span className="redirect-text">
                    Redirecting to Login...
                  </span>
                </div>
             </div>
          ) : (
            <form onSubmit={handleResetPassword}>
              <input 
                type='password' 
                placeholder='New Password' 
                onChange={(e) => setNewPassword(e.target.value)} 
                required
              />

              <input 
                type='password' 
                placeholder='Confirm New Password' 
                onChange={(e) => setConfirmPassword(e.target.value)} 
                required
              />

              {err && 
                <div className="error-message">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"></path>
                  </svg>

                  <span>
                    {err}
                  </span>
                </div>
              }

              <button type="submit" disabled={isLoading}>
                {isLoading ? "Updating..." : "Update Password"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;